import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'camelcase' })
export class CamelcasePipe implements PipeTransform {

  transform(input: string): string {
    return input && input.length
      ? input
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (letter) => letter.toUpperCase())
      : input;
  }
}
